import { REQUEST, SHOW_ORDER_DETAIL } from '../actions/action_types';
import * as PRODCUT from '../actionTypes/ec';

/*
漸進移除 reducer request_state_reducer 內容過來
request_state_reducer 全部混在一起 非常亂 而且還是物件形式
先前開發將 API 狀態移進該頁 reducer 但應該都移回此 reducer

兩點注意：
  1. 按照目前 API server 分類
  2. 只能放 API 狀態 不要放參數包含 token、queryString、id 有的沒有的
  3. 若從某個頁面離開，要將該頁面打過 API 狀態都還原成 INIT 初始值避免下次進入該頁面就不打 API 了
  4. 為避免從 actionTypes/product import 太多行 code，一律 * as XXX 的方式 import 進來
 */

const initState = {
  getProductDetail: REQUEST.INIT,
  getProductItems: REQUEST.INIT,
  getProductLocaltour: REQUEST.INIT,
  getProductTicket: REQUEST.INIT,
  getProductCarRental: REQUEST.INIT,
  getProductSimWifi: REQUEST.INIT,
  checkProduct: REQUEST.INIT,
  getCostEstimation: REQUEST.INIT,
  getCreditCards: REQUEST.INIT,
  deleteCreditCards: REQUEST.INIT,
  postPay: REQUEST.INIT,
  getOrderList: REQUEST.INIT,
  getOrderDetail: REQUEST.INIT,
  putOrderInsureds: REQUEST.INIT,
  putOrderPartners: REQUEST.INIT
};
const copyState = JSON.parse(JSON.stringify(initState));

export default (state = copyState, action) => {
  switch (action.type) {
    // FETCH_PRODUCT_DETAIL
    case PRODCUT.FETCH_PRODUCT_DETAIL.LOADING:
      return {
        ...state,
        getProductDetail: REQUEST.LOADING
      };
    case PRODCUT.FETCH_PRODUCT_DETAIL.SUCCESS:
      return {
        ...state,
        getProductDetail: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_PRODUCT_DETAIL.FAIL:
      return {
        ...state,
        getProductDetail: REQUEST.FAIL
      };
    // FETCH_PRODUCT_ITEMS
    case PRODCUT.FETCH_PRODUCT_ITEMS.LOADING:
      return {
        ...state,
        getProductItems: REQUEST.LOADING
      };
    case PRODCUT.FETCH_PRODUCT_ITEMS.SUCCESS:
      return {
        ...state,
        getProductItems: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_PRODUCT_ITEMS.FAIL:
      return {
        ...state,
        getProductItems: REQUEST.FAIL
      };
    // FETCH_PRODUCT_LOCALTOUR
    case PRODCUT.FETCH_PRODUCT_LOCALTOUR.LOADING:
      return {
        ...state,
        getProductLocaltour: REQUEST.LOADING
      };
    case PRODCUT.FETCH_PRODUCT_LOCALTOUR.SUCCESS:
      return {
        ...state,
        getProductLocaltour: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_PRODUCT_LOCALTOUR.FAIL:
      return {
        ...state,
        getProductLocaltour: REQUEST.FAIL
      };
    // FETCH_PRODUCT_TICKET
    case PRODCUT.FETCH_PRODUCT_TICKET.LOADING:
      return {
        ...state,
        getProductTicket: REQUEST.LOADING
      };
    case PRODCUT.FETCH_PRODUCT_TICKET.SUCCESS:
      return {
        ...state,
        getProductTicket: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_PRODUCT_TICKET.FAIL:
      return {
        ...state,
        getProductTicket: REQUEST.FAIL
      };
    // FETCH_PRODUCT_CAR_RENTAL
    case PRODCUT.FETCH_PRODUCT_CAR_RENTAL.LOADING:
      return {
        ...state,
        getProductCarRental: REQUEST.LOADING
      };
    case PRODCUT.FETCH_PRODUCT_CAR_RENTAL.SUCCESS:
      return {
        ...state,
        getProductCarRental: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_PRODUCT_CAR_RENTAL.FAIL:
      return {
        ...state,
        getProductCarRental: REQUEST.FAIL
      };
    // FETCH_PRODUCT_SIM_WIFI
    case PRODCUT.FETCH_PRODUCT_SIM_WIFI.LOADING:
      return {
        ...state,
        getProductSimWifi: REQUEST.LOADING
      };
    case PRODCUT.FETCH_PRODUCT_SIM_WIFI.SUCCESS:
      return {
        ...state,
        getProductSimWifi: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_PRODUCT_SIM_WIFI.FAIL:
      return {
        ...state,
        getProductSimWifi: REQUEST.FAIL
      };

    // CHECK_PRODUCT_STOCK
    case PRODCUT.CHECK_PRODUCT_STOCK.LOADING:
      return {
        ...state,
        checkProduct: REQUEST.LOADING
      };
    case PRODCUT.CHECK_PRODUCT_STOCK.SUCCESS:
      return {
        ...state,
        checkProduct: REQUEST.SUCCESS
      };
    case PRODCUT.CHECK_PRODUCT_STOCK.FAIL:
      return {
        ...state,
        checkProduct: REQUEST.FAIL
      };
    // FETCH_PRODUCT_COST_ESTIMATION
    case PRODCUT.FETCH_PRODUCT_COST_ESTIMATION.LOADING:
      return {
        ...state,
        getCostEstimation: REQUEST.LOADING
      };
    case PRODCUT.FETCH_PRODUCT_COST_ESTIMATION.SUCCESS:
      return {
        ...state,
        getCostEstimation: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_PRODUCT_COST_ESTIMATION.FAIL:
      return {
        ...state,
        getCostEstimation: REQUEST.FAIL
      };
    // FETCH_CREDIT_CARDS
    case PRODCUT.FETCH_CREDIT_CARDS.LOADING:
      return {
        ...state,
        getCreditCards: REQUEST.LOADING
      };
    case PRODCUT.FETCH_CREDIT_CARDS.SUCCESS:
      return {
        ...state,
        getCreditCards: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_CREDIT_CARDS.FAIL:
      return {
        ...state,
        getCreditCards: REQUEST.FAIL
      };
    // DELETE_CREDIT_CARDS
    case PRODCUT.DELETE_CREDIT_CARDS.LOADING:
      return {
        ...state,
        deleteCreditCards: REQUEST.LOADING
      };
    case PRODCUT.DELETE_CREDIT_CARDS.SUCCESS:
      return {
        ...state,
        deleteCreditCards: REQUEST.SUCCESS
      };
    case PRODCUT.DELETE_CREDIT_CARDS.FAIL:
      return {
        ...state,
        deleteCreditCards: REQUEST.FAIL
      };
    // POST_PAY
    case PRODCUT.POST_PAY.LOADING:
      return {
        ...state,
        postPay: REQUEST.LOADING
      };
    case PRODCUT.POST_PAY.SUCCESS:
      return {
        ...state,
        postPay: REQUEST.SUCCESS
      };
    case PRODCUT.POST_PAY.FAIL:
      return {
        ...state,
        postPay: REQUEST.FAIL
      };

    // FETCH_ORDER_LIST
    case PRODCUT.FETCH_ORDER_LIST.LOADING:
      return {
        ...state,
        getOrderList: REQUEST.LOADING
      };
    case PRODCUT.FETCH_ORDER_LIST.SUCCESS:
      return {
        ...state,
        getOrderList: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_ORDER_LIST.FAIL:
      return {
        ...state,
        getOrderList: REQUEST.FAIL
      };

    // FETCH_ORDER_DETAIL
    case PRODCUT.FETCH_ORDER_DETAIL.LOADING:
      return {
        ...state,
        getOrderDetail: REQUEST.LOADING
      };
    case PRODCUT.FETCH_ORDER_DETAIL.SUCCESS:
      return {
        ...state,
        getOrderDetail: REQUEST.SUCCESS
      };
    case PRODCUT.FETCH_ORDER_DETAIL.FAIL:
      return {
        ...state,
        getOrderDetail: REQUEST.FAIL
      };

    // [!DEPRECATED] use PUT_ORDER_PARTNERS instead
    // PUT_ORDER_INSUREDS
    case PRODCUT.PUT_ORDER_INSUREDS.LOADING:
      return {
        ...state,
        putOrderInsureds: REQUEST.LOADING
      };
    case PRODCUT.PUT_ORDER_INSUREDS.SUCCESS:
      return {
        ...state,
        putOrderInsureds: REQUEST.SUCCESS
      };
    case PRODCUT.PUT_ORDER_INSUREDS.FAIL:
      return {
        ...state,
        putOrderInsureds: REQUEST.FAIL
      };

    // PUT_ORDER_PARTNERS
    case PRODCUT.PUT_ORDER_PARTNERS.LOADING:
      return {
        ...state,
        putOrderPartners: REQUEST.LOADING
      };
    case PRODCUT.PUT_ORDER_PARTNERS.SUCCESS:
      return {
        ...state,
        putOrderPartners: REQUEST.SUCCESS
      };
    case PRODCUT.PUT_ORDER_PARTNERS.FAIL:
      return {
        ...state,
        putOrderPartners: REQUEST.FAIL
      };

    // INIT
    case PRODCUT.INIT_EC_REDUX:
      return initState;
    // Itinerary ec order card
    case SHOW_ORDER_DETAIL:
      return !action.payload.isShow ? initState : state;
    default:
      return state;
  }
};
